var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3988 18.4349L8.70588 18.3674C7.5102 18.3439 6.31154 18.3908 5.13931 18.147C3.35607 17.7827 3.22973 15.9965 3.09754 14.4982C2.91539 12.3918 2.98591 10.2471 3.32964 8.15831C3.52369 6.98626 4.28736 6.28688 5.46834 6.21078C9.45503 5.93458 13.4682 5.96731 17.4461 6.09617C17.8662 6.10798 18.2892 6.17255 18.7034 6.24604C20.7483 6.60447 20.7981 8.62865 20.9307 10.3326C21.0629 12.0542 21.007 13.7846 20.7544 15.4944C20.5517 16.9101 20.1638 18.0973 18.5271 18.2119C16.4764 18.3618 14.4728 18.4825 12.4164 18.444C12.4165 18.4349 12.4046 18.4349 12.3988 18.4349ZM10.2277 14.8508C11.7731 13.9635 13.289 13.091 14.8255 12.2096C13.2772 11.3224 11.7642 10.4499 10.2277 9.56851V14.8508Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2e1bacffdec949b4f4afa5dcb1f09243.svg";
export { ForwardRef as ReactComponent };